import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import BackToTopButton from '../ExtraFeatures/BackToTopButton';
import MyImg from "../../Assets/MyImg.jpg";
import LeetcodeImg from "../../Assets/LeetcodeImg.png";
import Toolstack from "./Toolstack";
import GfGImg from "../../Assets/GfGImg.png";
// import link from "react-router-dom";


export default function About() {
  return (
    <Container fluid className="about-section" id="about_id">
      {/* <Particle /> */}
      <BackToTopButton />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "0px",
              paddingBottom: "20px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={4}
            style={{ paddingTop: "20px", paddingBottom: "50px" }}
            className="about-img"
          >
            <a href="https://www.linkedin.com/in/asif-alam-ba19531b0/" target="_blank"> <img src={MyImg} alt="about" className="img-fluid" /> </a>
          </Col>
        </Row>
        <hr/>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <hr/>
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>

        <Toolstack />
        <hr/>
        <Github />
            <br/>
        <hr/>
        <Col
          md={4}
          // style={{ paddingTop: "20px", paddingBottom: "50px" }}
          style={{ justifyContent: "center", paddingBottom: "10px", width: "95%", alignContent: "center" }}
          className="about-img"
        >
          <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
            <strong className="purple">Competitve Coding</strong><br/>
          </h1>
          <h3><strong className="purple">Leetcode</strong></h3>
          <a href="https://leetcode.com/code_asif/" target="_blank" > <img src={LeetcodeImg} alt="about" className="img-fluid" /> </a>
          <br/>
          <br/>
          <br/>
          <hr/>

            {/* <link to = "https://leetcode.com/code_asif/" > <img src={LeetcodeImg} alt="leetcode" className="img-fluid" /> </link> */}

            <h3><strong className="purple">GeeksforGeeks</strong></h3>
            <a href="https://auth.geeksforgeeks.org/user/asifcs26" target="_blank" > <img src={GfGImg} alt="about" className="img-fluid" /> </a>
        </Col>
      </Container>
    </Container>
  );
}